// extracted by mini-css-extract-plugin
export default {"searchable":"_searchable_YUa9+i"};